import { render, staticRenderFns } from "./DualGraphicsSecondComponent.vue?vue&type=template&id=14c10769&scoped=true"
import script from "./DualGraphicsSecondComponent.vue?vue&type=script&lang=js"
export * from "./DualGraphicsSecondComponent.vue?vue&type=script&lang=js"
import style0 from "./DualGraphicsSecondComponent.vue?vue&type=style&index=0&id=14c10769&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c10769",
  null
  
)

export default component.exports